// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13x6P","comment":"styles_comment__LRe8-"};